import React from "react";
import { Grid, Paper, TextField } from "@mui/material";

export default function MailaddressField({ register, classes, errors }) {
  return (
    <Paper elevation={0}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}
      >
        <Grid
          item
          xs={4}
          sm={2.5}
          sx={{ fontWeight: "bold", p: "20px", pl: "20px" }}
        >
          メールアドレス
        </Grid>
        <Grid item xs={8} sm={9.5} sx={{ py: "20px", pl: "15px", fontSize: 16 }}>
          <TextField
            sx={classes}
            variant="standard"
            required
            type="email"
            {...register("email")}
            error={Boolean(errors?.email)}
            helperText={errors?.email?.message}
            fullWidth
            id="email"
            InputProps={{
              disableUnderline: true,
              style: { fontSize: 16 },
              autoComplete: "new-email",
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}